import { lazy } from "react";
import { RouteConfig } from "../../../../types/RouteConfig";

export const calorCashbackViewRoute: RouteConfig<'with-page'> = {
    name: 'My Cashback',
    path: '/rewards/calor/cashback-deal',
    context: 'member',
    page: lazy(() => import('.')),
    flags: ['member-route'],
    permissions: ['rewards'],
}